import { PERMISSIONS } from "@/rbac/permissions.js";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";

const { INSPVIEW, INVVIEW, SPNVIEW, IRGVIEW, APRASVIEW } = PERMISSIONS;

const VIEW_PERMISSIONS = [INSPVIEW, INVVIEW, SPNVIEW, IRGVIEW, APRASVIEW];

export const MANAGEMENT_LINKS_PERMISSIONS = {
  [ACCESS_LEVELS.VIEW]: VIEW_PERMISSIONS,
};
